import { waitAsync } from '../utils';
import { Route } from 'react-router-dom';

const ListFeesAction = "LIST_FEES";
const ModifyFeeAction = "MODIFY_FEE";
const SaveFeeAction = "SAVE_FEE";
const DeleteFeeAction = "DELETE_FEE";
const Waiting = "WAITING_FEES";

const initialState = {
    list: [],
    nowWainting: false,
    editing: null,
};
export const actionCreators = {
    /**
     * list fees
     */
    listFees: (token) => async (dispatch) => {
        const routeurl = `api/user/feeManagements/list`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const list = await response.json();
                dispatch({ type: ListFeesAction, list });
                return list;
            } else {
                throw new Error('データ取得に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集を保存します。
     */
    save: (token, fee) => async (dispatch) => {
        var routeurl = `api/user/feeManagements`;

        dispatch({ type: Waiting, nowWainting: true });

        try {
            let response = await fetch(routeurl, {
                method: 'post',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
                body: JSON.stringify(fee)
            })

            var addNew = false;

            // seqがまだないものは新規登録とみなす
            if (fee.seq == null || fee.seq == '') {

                addNew = true;
            }

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {

                    dispatch({ type: SaveFeeAction, fee: resp.result, addNew });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '登録に失敗しました。');

                }
            } else {
                throw new Error('登録に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 手数料設定を削除します。
     */
    delete: (token, fee) => async (dispatch) => {
        var routeurl = `api/user/feeManagements`;

        dispatch({ type: Waiting, nowWainting: true });

        var merchantId = fee.id;
        var seq = fee.seq;
        if (!merchantId || !seq) {
            throw new Error(`削除エラー。id=${merchantId} seq=${seq}`);
        }

        routeurl += `?id=${merchantId}&seq=${seq}`;

        try {
            let response = await fetch(routeurl, {
                method: 'delete',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                }
            })

            const resultStatus = response.status;

            if (resultStatus == 200) {
                const resp = await response.json();

                if (resp.error_message == null) {
                    dispatch({ type: DeleteFeeAction, fee:fee });
                    return resp.result;

                } else {

                    throw new Error(resp.error_message || '削除に失敗しました。');

                }
            } else {
                throw new Error('削除に失敗しました。');
            }
        } finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 編集用のモデルをロードします。
     */
    loadEditModel: (token, merchantId, seq, creditCardPaymentAgencyId) => async (dispatch) => {
        var routeurl = `api/user/feeManagements/edit`;

        routeurl += `?id=${merchantId}&seq=${seq}&creditCardPaymentAgencyId=${creditCardPaymentAgencyId}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const fee = await response.json();
                dispatch({ type: ModifyFeeAction, fee });
                return fee;
            } else {
                throw new Error('手数料設定情報取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },

    /**
     * 期間の開始日を取得するために手数料情報を取得します。
     */
    loadPrevInfo: (token, merchantId) => async (dispatch) => {
        var routeurl = `api/user/feeManagements/previnfo`;

        routeurl += `?id=${merchantId}`;

        dispatch({ type: Waiting, nowWainting: true });

        try {

            let response = await fetch(routeurl, {
                method: 'get',
                headers: {
                    "Authorization": "Bearer " + token,
                    'Content-type': 'application/json; charset=UTF-8'
                },
            })
            const resultStatus = response.status;
            if (resultStatus == 200) {
                const previnfo = await response.json();
                return previnfo;
            } else {
                throw new Error('手数料設定情報取得に失敗しました。');
            }
        }
        finally {
            dispatch({ type: Waiting, nowWainting: false });
        }
    },
}

export const reducer = (state, action) => {
    state = state || initialState;
    
    if (action.type === Waiting) {
        return {
            ...state,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ModifyFeeAction) {
        return {
            ...state,
            editing: action.fee,
            nowWainting: action.nowWainting
        };
    }
    if (action.type === ListFeesAction) {
        return {
            ...state,
            list: action.list,
            nowWainting: action.nowWainting
        };
    }
    // 登録・編集
    if (action.type === SaveFeeAction) {

        //if (action.addNew) {
        //    //登録の場合はリストに追加
        //    state.list.push(action.fee);
        //    state.list.sort(function (a, b) {
        //        if (a.merchant_name < b.merchant_name) return -1;
        //        if (a.merchant_name > b.merchant_name) return 1;
        //        return 0;
        //    });
        //}
        //else {
        //    // 編集の場合はリストを変更
        //    var idx = state.list.findIndex((o) => o.id == action.fee.id && o.seq == action.fee.seq);
        //    state.list[idx] = action.fee;
        //}

        return {
            ...state,
            editing: action.fee
        };
    }
    // 削除
    if (action.type === DeleteFeeAction) {
        // 削除の場合はリストから除去
        state.list = state.list.filter(f => !(f.id == action.fee.id && f.seq == action.fee.seq));

        return {
            ...state,
            editing: action.fee
        };
    }
    return state;
}